// extracted by mini-css-extract-plugin
module.exports = {"root":"alert_root__h7fGQ","description":"alert_description__OO5Mo","button":"alert_button__ZDAnt"};